import { createSelector } from '@reduxjs/toolkit';

const rootSelector = ({ extension }) => extension;

export const getExtInstalled = createSelector([rootSelector], ({ extInstalled }) => extInstalled);
export const getIOSExtInstalled = createSelector([rootSelector], ({ iosExtInstalled }) => iosExtInstalled);
